<div>
  <div class="header-container">
    Søknaden feilet ved utsendelse
  </div>
  <div class="content-container ">
    <span>Byggesøknaden for {{application.address | formatAddress}} feilet dessverre under utsending {{application.sendDate | date: 'yyyy-MM-dd HH:mm'}}.</span>
    <span>Søknaden vil bli behandlet videre av {{application.contactCompanyName}}.</span>
  </div>
</div>
